import { Injectable } from '@angular/core';
import { ApiUrlService } from '../shared-services/api-url.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class StateServicesService {

  constructor(private base_url:ApiUrlService, private http:HttpClient) { 
    
    console.log( 'BASE_URL',this.base_url.BASE_STATE);
  }
  // dummyService(obj: any): Observable<any> {
  //   const url = `${this.base_url.BASE_STATE}/path/sub`;
  //   return this.http.post(url, obj);
  // }

  // Subscribe the services in below way 

  // this.stateService.createNewState(statePayload).subscribe({
  //   next: (response) => {
  //     console.log('Deleted request ', response);
  //   },
  //   error: (error) => {
  //     console.error('Error  deleting state:', error);
  //   },
  //   complete: () => {
  //     console.log('Delete request completed');
  //     // clean-up logic for this 
  //   }
  // });

  createNewState(req: any): Observable<any> {
    const url = `${this.base_url.BASE_STATE}/create`;
    return this.http.post(url, req);
  }
  getStateWithPagination(paginationData:any): Observable<any> {
    const url = `${this.base_url.BASE_STATE}/get_with_paginate?limit=${paginationData.limit}&currentPage=${paginationData.currentPage}`;
    return this.http.get(url);
  }
  getAState(id:any): Observable<any> {
    const url = `${this.base_url.BASE_STATE}/${id}`;
    return this.http.get(url);
  }
  UpdateAState(req: any): Observable<any> {
    const url = `${this.base_url.BASE_STATE}/update/${req?.id}`;
    return this.http.put(url,req);
  }
  deleteState(stateReq: string): Observable<any> {
    const url = `${this.base_url.BASE_STATE}/delete`;
    return this.http.post(url,stateReq);
  }

}
